import { ResponseError } from "../../../services/api";
import { Config, Data } from "../../../utils/newTableHelper";

export enum HomeOrdersTypes {
  'LOAD_REQUEST' = '@homeOrders/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@homeOrders/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@homeOrders/LOAD_FAILURE',
}

export interface HomeOrdersState {
  readonly data: Data[];
  readonly config?: Config;
  readonly loading: boolean;
  readonly error?: ResponseError;
}
